import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Box,
  Button
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { NavLink } from 'react-router-dom';

import { STRINGS } from 'src/commons';
const CustomTable = ({
  data = [],
  headers = [],
  dataKeysSequence = [],
  onEdit,
  onDelete,
  limit = 10,
  handlePageChange = () => {},
  onClickRow = () => {},
  page = 0,
  NO_DATA_MESSAGE = STRINGS.NO_DATA_FOUND,
  handleOpenModal = () => {},
  handleNavigate = () => {}
}) => {
  return (
    <>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(0, limit)?.length ? (
                data.slice(0, limit).map((dataItem, index) => (
                  <TableRow
                    hover
                    key={index}
                    onClick={() => onClickRow(dataItem)}
                  >
                    {dataKeysSequence?.map((key, itemIndex) => (
                      <TableCell key={itemIndex}>
                        {key === 'plan' ? (
                          dataItem[key]?.name
                        ) : key === 'batch' ? (
                          dataItem[key]?.name
                        ) : key === 'trainer' ? (
                          dataItem[key]?.name
                        ) : key === 'actions' ? (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '.8rem'
                            }}
                          >
                            <Button
                              variant="contained"
                              sx={{
                                textTransform: 'none'
                              }}
                              onClick={() => {
                                onEdit(dataItem);
                              }}
                              color="error"
                            >
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                textTransform: 'none'
                              }}
                              onClick={() => {
                                onDelete(dataItem);
                              }}
                              color="success"
                            >
                              Delete
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                textTransform: 'none'
                              }}
                              onClick={() => {
                                handleOpenModal(dataItem);
                              }}
                              color="primary"
                            >
                              Payment
                            </Button>

                            <Button
                              variant="contained"
                              sx={{
                                textTransform: 'none'
                              }}
                              color="primary"
                            >
                              <NavLink
                                style={{ color: 'white' }}
                                to={`/app/payment/${dataItem['_id']}`}
                              >
                                Payments
                              </NavLink>
                            </Button>
                          </Box>
                        ) : (
                          dataItem[key]
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                <TableRow hover>
                  <TableCell
                    colSpan={headers.length}
                    style={{ textAlign: 'center' }}
                  >
                    {NO_DATA_MESSAGE}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={data?.length}
        onPageChange={handlePageChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[]}
      />
    </>
  );
};

export default CustomTable;
